import React from 'react';
import DispatchMap from 'components/DispatchMap';

const DashboardMapPage = () => <DispatchMap />;

export default DashboardMapPage;
